import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { FormLabel, Typography } from '@material-ui/core';
import { useStyles } from './FloatingPopover.styles';
import { Popover } from '../../popover/popover';
export function FloatingPopover(props) {
    var eyebrow = props.eyebrow, title = props.title, text = props.text, _a = props.tooltipId, tooltipId = _a === void 0 ? '' : _a, isOpen = props.isOpen, onNavigateTooltip = props.onNavigateTooltip, _b = props.onCloseHandler, onCloseHandler = _b === void 0 ? function () { } : _b, top = props.top;
    var tooltipClasses = useStyles();
    var tabIndex = onNavigateTooltip ? 0 : -1;
    var linkClassName = onNavigateTooltip ? tooltipClasses.link : null;
    var onNavigate = function (e) {
        var isValidEvent = (e === null || e === void 0 ? void 0 : e.charCode) === 13 || (e === null || e === void 0 ? void 0 : e.clientX);
        if (onNavigateTooltip && isValidEvent) {
            onNavigateTooltip();
        }
    };
    return (React.createElement(Popover, { top: top || '0px', dark: true, isOpen: isOpen, isCloseIconVisible: true, closeOnClick: true, closeOnDocumentClick: false, onCloseHandler: onCloseHandler, position: "bottom", portalContainer: document.body, targetContent: React.createElement("div", { className: tooltipClasses.anchor }), popoverContent: React.createElement("div", { className: clsx(tooltipClasses.root, linkClassName, tooltipId, 'new-feature-tooltip'), role: "button", tabIndex: tabIndex, onClick: onNavigate, onKeyDown: onNavigate },
            React.createElement(FormLabel, { className: tooltipClasses.tagline }, eyebrow || 'NEW FEATURE'),
            React.createElement(Typography, { className: tooltipClasses.title, variant: "h2" }, title),
            React.createElement(Typography, { className: tooltipClasses.copy, variant: "body1" }, text)) }));
}
FloatingPopover.propTypes = {
    eyebrow: PropTypes.string,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    isOpen: PropTypes.bool,
    tooltipId: PropTypes.string,
    onCloseHandler: PropTypes.func,
    onNavigateTooltip: PropTypes.func,
    top: PropTypes.string,
};
//# sourceMappingURL=FloatingPopover.js.map